<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>

<cigna-process-steps
  class="cg-hide-for-print"
  [steps]="steps$ | async"
  [activeStep]="2"
  [hiddenSteps]="hiddenSteps$ | async"
></cigna-process-steps>

<h3 class="cg-h3">{{ 'am.accessIndividual.header' | translate }}</h3>
<p class="cg-margin-top-none cg-margin-bottom-lg">
  {{ 'am.accessIndividual.subHeader' | translate }} <br />
  <button
    style="padding: 0"
    cignaButton="link"
    (click)="openExplainAccessDialog()"
  >
    {{ 'am.accessIndividual.helpLink' | translate }}
  </button>
</p>

<cigna-collapsible-group
  groupLabel="all users"
  data-test="wam-collapsible-group"
  [showAction]="(selectedUsersLength$ | async)! > 1"
>
  <ng-container
    *ngFor="
      let user of selectedUsers$ | async;
      first as firstUser;
      last as lastUser;
      trackBy: trackByUserId
    "
  >
    <cigna-collapsible-block
      [expanded]="firstUser"
      [headerText]="generateUserHeaderLabel(user)"
      data-test="assign-individual-user-block"
    >
      <button
        *ngIf="!(firstUser && lastUser)"
        style="padding: 0"
        cignaButton="link"
        style="float: right; margin: 0.5em"
        (click)="openRemoveUserFromEditingDialog(user)"
      >
        {{ 'am.accessIndividual.removeUser' | translate }}
      </button>
      <div *ngIf="(userLob$ | async) === LOB_MEDBH" class="cg-margin-top-xs">
        {{ 'am.common.lobTinMessage' | translate }}
        <b>
          <a [href]="'/my-practice/manage-access' | crossOriginLink">{{
            'am.common.lobTinRedirect' | translate
          }}</a>
        </b>
      </div>
      <ng-container *ngFor="let tin of allTins$ | async; first as firstTin">
        <cigna-collapsible-item
          [headerText]="generateTinHeaderLabel(tin, user)"
          [expanded]="firstTin"
          data-test="assign-individual-tin-block"
        >
          <h4 class="cg-margin-top-none cg-margin-bottom-sm">
            {{ 'am.accessIndividual.entitlementHeader' | translate }}
          </h4>

          <div class="cg-contrast-block-on-dark">
            <cigna-entitlement-group
              [allEntitlements]="allEntitlements$ | async"
              [currentEntitlements]="getCurrentEntitlementsForTin(tin, user)"
              [showRevert]="diffEntitlements(tin, user)"
              [activeTin]="tin"
              [userJobRole]="user.jobRole"
              (applyByJobRole)="applyEntitlementsByJobRole(tin, user)"
              (revertToExisting)="revertToExistingAccess(tin, user)"
              (selectionsChange)="entitlementsChange($event, tin, user)"
            >
            </cigna-entitlement-group>
          </div>
        </cigna-collapsible-item>
      </ng-container>
    </cigna-collapsible-block>
  </ng-container>
</cigna-collapsible-group>

<div
  *ngIf="(changesValid$ | async) === false"
  style="display: inline-block"
  class="cg-error-msg"
>
  <cigna-icon type="exclamation-circle"></cigna-icon>
  <span>{{ 'am.accessIndividual.addUsersValidationError' | translate }}</span>
</div>

<div class="cg-margin-top-xl">
  <cigna-page-step-navigation
    [nextEnabled]="changesValid$ | async"
    nextButtonLabel="Review"
    (previous)="previousScreen()"
    (next)="nextScreen()"
  >
  </cigna-page-step-navigation>
</div>
